import { render, staticRenderFns } from "./emitHairstyleeditor.vue?vue&type=template&id=4aa93a43&scoped=true"
import script from "./emitHairstyleeditor.vue?vue&type=script&lang=js"
export * from "./emitHairstyleeditor.vue?vue&type=script&lang=js"
import style0 from "./emitHairstyleeditor.vue?vue&type=style&index=0&id=4aa93a43&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa93a43",
  null
  
)

export default component.exports